import { Component } from '@angular/core';
import { GovernoratesListComponent } from '../../../../../components/admin-dashboard-component/system-settings/governorates/governorates-list-component/governorates-list-component';

@Component({
  selector: 'app-governorates-list',
  imports: [GovernoratesListComponent],
  templateUrl: './governorates-list.html',
  styleUrl: './governorates-list.scss',
})
export class GovernoratesList {}
